(function () {
  var widget = document.querySelector('[data-floating-product-video]');
  if (!widget) return;

  var video = widget.querySelector('video');
  var expand = widget.querySelector('[data-fpv-expand]');
  var collapse = widget.querySelector('[data-fpv-collapse]');
  var close = widget.querySelector('[data-fpv-close]');
  var mute = widget.querySelector('[data-fpv-mute]');
  var key = 'floating-product-video-closed-' + widget.getAttribute('data-product-id');
  if (!video) return;

  function storage(method, value) {
    try {
      if (method === 'get') return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function play() {
    if (!video || document.hidden || widget.hidden) return;
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function pause() {
    if (video) video.pause();
  }

  function setExpanded(expanded) {
    widget.classList.toggle('is-expanded', expanded);
    expand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function setMuted(muted) {
    video.muted = muted;
    video.defaultMuted = muted;
    video.volume = muted ? 0 : 1;
    mute.setAttribute('aria-label', muted ? 'Unmute product video' : 'Mute product video');
    mute.setAttribute('aria-pressed', muted ? 'true' : 'false');
    mute.classList.toggle('is-muted', muted);
  }

  function setMobileOffset() {
    if (!window.matchMedia('(max-width: 767px)').matches) {
      widget.style.removeProperty('--fpv-bottom');
      return;
    }

    var offset = 88;
    ['.sticky-cart-single', '.gokwik-checkout', '#gokwik-buy-now', '.header-bottom-fixed'].forEach(function (selector) {
      var bar = document.querySelector(selector);
      if (!bar) return;
      var styles = window.getComputedStyle(bar);
      var rect = bar.getBoundingClientRect();
      var isBottomBar = (styles.position === 'fixed' || styles.position === 'sticky') && rect.bottom > window.innerHeight - 24;
      if (isBottomBar) offset = Math.max(offset, Math.ceil(rect.height + 16));
    });
    widget.style.setProperty('--fpv-bottom', offset + 'px');
  }

  if (storage('get')) {
    widget.hidden = true;
    pause();
    return;
  }

  expand.addEventListener('click', function () {
    setExpanded(!widget.classList.contains('is-expanded'));
    play();
  });

  collapse.addEventListener('click', function () {
    setExpanded(false);
    play();
  });

  close.addEventListener('click', function () {
    storage('set', '1');
    widget.hidden = true;
    pause();
  });

  mute.addEventListener('click', function () {
    setMuted(!video.muted);
    play();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pause();
    else play();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && widget.classList.contains('is-expanded')) setExpanded(false);
  });

  window.addEventListener('resize', setMobileOffset);
  window.addEventListener('load', setMobileOffset);
  setMuted(video.muted);
  setMobileOffset();
  play();
})();
